import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { SavedReportView, SavedReportViewReportType } from '../../../../../../models/saved-report-view';
import { SavedReportViewService } from '../../../../../../services/saved-report-view/saved-report-view.service';
import { AccountService } from '../../../../../../services/account/account.service';
import { ApiService } from '../../../../../../services/api/api.service';
import { dateStringFromISO8601, getStaffNameDisplay } from '../../../../../../utils';


@Component({
  selector: 'app-view-saved-report-views-modal',
  templateUrl: './view-saved-report-views-modal.component.html',
  styleUrls: ['./view-saved-report-views-modal.component.css']
})
export class ViewSavedReportViewsModalComponent implements OnInit {
  @Input() reportType: SavedReportViewReportType;
  @Input() savedViewEdited: boolean;
  @Input() savedViewSelectedCallback: (srv: SavedReportView | null) => undefined;
  @Input() createNewSavedViewCallback: () => undefined;
  @Input() setPersonalDefaultCallback: () => undefined;
  @Input() setOrganizationDefaultCallback: () => undefined;

  public srvs: SavedReportView[];

  public loadingSrvs = true;

  public serverError: number = null;

  // Whether the current user may set the organization-wide default view
  // (PRO-1243). Only organization admins may do so.
  public isOrganizationAdmin = false;

  // The view IDs currently set as the user's personal default and the
  // organization default for this report, used to badge the matching rows.
  public personalDefaultViewId: number | undefined;
  public organizationDefaultViewId: number | undefined;

  public readonly getStaffNameDisplay = getStaffNameDisplay;
  public readonly dateStringFromISO8601 = dateStringFromISO8601;

  constructor(
    public activeModal: NgbActiveModal,
    private savedReportViewService: SavedReportViewService,
    private accountService: AccountService,
    public apiService: ApiService,
  ) {}

  ngOnInit() {
    const myAccount = this.accountService.getMyAccount();
    this.isOrganizationAdmin = myAccount.is_organization_admin;
    this.personalDefaultViewId = myAccount.default_report_view_ids?.[this.reportType];
    this.organizationDefaultViewId =
      myAccount.organization_default_report_view_ids?.[this.reportType];
    this.loadSrvs();
  }

  private loadSrvs() {
    this.loadingSrvs = true;

    this.savedReportViewService
      .getSavedReportViews(1, 100, {report_type: this.reportType})
      .then(result => {
        this.srvs = result.results;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingSrvs = false; });
  }
}
